import React, { useEffect, useState } from "react";
import Slider from "react-slick";

const advantages = [
  "🌐 全球加速节点，智能路由优化，随时随地高速访问",
  "🔒 高强度加密技术，保护您的隐私数据不被窥探",
  "💡 简洁明了的控制面板，操作简单易上手",
  "🧠 自主研发核心技术，持续迭代更新",
  "👨‍💼 海外团队运营，7x24 小时技术支持",
  "🚀 支持直连/中转/专线，满足不同使用场景",
];
const testimonials = [
  {
    name: "张先生 · IT工程师",
    comment: "用了几个月了，速度快且稳定，特别适合在外网远程工作的场景。",
    avatar: "https://i.pravatar.cc/150?img=1",
  },
  {
    name: "李小姐 · 海外留学生",
    comment: "能访问国内和海外资源，对我课业帮助很大，真心推荐！",
    avatar: "https://i.pravatar.cc/150?img=2",
  },
  {
    name: "王先生 · 独立开发者",
    comment: "线路选择多样，控制面板也非常清爽，用着放心。",
    avatar: "https://i.pravatar.cc/150?img=3",
  },
  {
    name: "赵小姐 · 跨境电商",
    comment: "稳定连接海外平台，发货跟单都很顺利，强烈推荐！",
    avatar: "https://i.pravatar.cc/150?img=4",
  },
  {
    name: "Chris · 数字游民",
    comment: "从东南亚用到欧洲，体验始终如一，客服也很耐心。",
    avatar: "https://i.pravatar.cc/150?img=5",
  },
  {
    name: "林先生 · 外企职员",
    comment: "公司推荐使用的加速工具，效率和安全都令人满意。",
    avatar: "https://i.pravatar.cc/150?img=6",
  },
];


const Home = () => {
  const [currentAdv, setCurrentAdv] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentAdv((prev) => (prev + 1) % advantages.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const url = new URL(window.location.href);
    const r = url.searchParams.get("r");
    if (r) {
      window.location.href = `/register?r=${r}`;
    }
  }, []);
  useEffect(() => {
    const url = new URL(window.location.href);
    const r = url.searchParams.get("r");
    if (r) {
      window.location.href = `/register?r=${r}`;
    }
  }, []);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024, // tablet
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 640, // mobile
        settings: { slidesToShow: 1 },
      },
    ],
  };

  return (
    <main className="text-gray-900">
      <section className="relative bg-gradient-to-r from-blue-500 via-indigo-500 to-purple-500 h-[500px]">
        <div className="absolute inset-0 bg-black/30"></div>
        <div className="relative z-10 h-full flex flex-col justify-center items-center text-white text-center px-4">
          <h1 className="text-5xl font-bold mb-4 drop-shadow-md">
            {process.env.REACT_APP_NAME}，畅游自由的网络世界
          </h1>
          <p className="text-xl mb-6 drop-shadow-md max-w-2xl">
            安全、可靠、实惠的网络加速服务，突破地域限制，畅享全球资源！
          </p>
          <div className="flex space-x-4">
            <a href="/plan" className="bg-white text-blue-700 hover:bg-gray-100 transition px-6 py-3 rounded-full font-medium shadow">
              🚀 立即选购
            </a>
            <a href="/dashboard" className="bg-blue-600 hover:bg-blue-700 transition px-6 py-3 rounded-full text-white font-medium shadow-lg">
              🎯 进入面板
            </a>
          </div>
        </div>
        <div className="absolute bottom-6 w-full text-center text-xl text-white font-medium transition-all duration-500 ease-in-out min-h-[10px]">
          {advantages[currentAdv]}
        </div>
      </section>

      <section className="py-20 px-4">
        <h2 className="text-3xl font-bold text-center mb-12">客户评价</h2>
        <div className="max-w-6xl mx-auto">
          <Slider {...settings}>
            {testimonials.map((item, i) => (
              <div key={i} className="px-3">
                <div className="bg-white p-6 rounded-xl shadow hover:shadow-md transition h-full flex flex-col">
                  <div className="flex items-center mb-4 space-x-4">
                    <img
                      src={item.avatar}
                      alt={item.name}
                      className="w-16 h-16 rounded-full object-cover border-4 border-white shadow-lg"
                    />
                    <div>
                      <div className="font-semibold text-lg text-gray-900">{item.name}</div>
                      <div className="text-sm text-gray-600">{item.position}</div> {/* 如果你需要显示职位 */}
                    </div>
                  </div>
                  <p className="text-gray-700 text-sm flex-1">“{item.comment}”</p>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </section>
      <section className="bg-gradient-to-br bg-white text-black py-24 px-6">
        <div className="max-w-5xl mx-auto text-center">
          <h2 className="text-4xl font-bold mb-6">🎉 推广返利</h2>
          <p className="text-lg mb-10 max-w-2xl mx-auto text-black/90">
            邀请好友使用 {process.env.REACT_APP_NAME}，每笔消费您都可获得持续返利。返利自动累计、实时可查，轻松开启长期收益模式。
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 text-left text-black/90">
            <div className="bg-white/10 backdrop-blur p-6 rounded-xl shadow-md hover:shadow-lg transition">
              <h3 className="text-xl font-semibold mb-2">🔗 永久绑定</h3>
              <p className="text-sm">邀请成功后将永久绑定账户，后续所有消费自动返利，无需额外操作。</p>
            </div>
            <div className="bg-white/10 backdrop-blur p-6 rounded-xl shadow-md hover:shadow-lg transition">
              <h3 className="text-xl font-semibold mb-2">💼 多种提现方式</h3>
              <p className="text-sm">支持 <strong>支付宝</strong>、<strong>微信</strong> 和 <strong>虚拟币</strong> 提现，到账快速灵活便捷。</p>
            </div>
            <div className="bg-white/10 backdrop-blur p-6 rounded-xl shadow-md hover:shadow-lg transition">
              <h3 className="text-xl font-semibold mb-2">📈 数据清晰透明</h3>
              <p className="text-sm">支持实时查看推广记录与收益明细，数据一目了然。</p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 px-6">
        <h2 className="text-3xl font-bold text-center mb-12">快速上手只需三步</h2>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 text-center">
          {[
            { step: "1️⃣", title: "注册账户", desc: "填写资料快速注册。" },
            { step: "2️⃣", title: "选择套餐", desc: "按需选购套餐，立享服务。" },
            { step: "3️⃣", title: "一键连接", desc: "导入订阅，即刻畅游全球。" },
          ].map((item, i) => (
            <div key={i}>
              <div className="text-5xl text-blue-500 mb-4">{item.step}</div>
              <h3 className="text-xl font-semibold mb-2">{item.title}</h3>
              <p className="text-gray-600">{item.desc}</p>
            </div>
          ))}
        </div>
      </section>
    </main>
  );
};

export default Home;
